interface PriceData {
  quotation?: number | string | null;
  deliveryCost?: number | string | null;
  [key: string]: any;
}

const VAT_RATE = 10 / 100;

/**
 * undefined를 인자로 받는경우 모두 0으로 반환.
 */
export const getPriceDatas = (data?: PriceData) => {
  let valueOfSupply = data?.quotation ?? 0;
  let deliveryCost = data?.deliveryCost ?? 0;

  if (typeof valueOfSupply === 'string') {
    valueOfSupply = Number(valueOfSupply ?? 0);
    valueOfSupply = Number.isNaN(valueOfSupply) ? 0 : valueOfSupply;
  }

  if (typeof deliveryCost === 'string') {
    deliveryCost = Number(deliveryCost ?? 0);
    deliveryCost = Number.isNaN(deliveryCost) ? 0 : deliveryCost;
  }

  const tax = Math.floor(valueOfSupply * VAT_RATE);
  const totalAmount = valueOfSupply + tax + deliveryCost;

  return {
    /** 공급가액 (견적금액) */
    valueOfSupply,
    /** 세액(부가세, 공금가액 * 10%) */
    tax,
    /** 배송비 (세액계산에서 제외됨) */
    deliveryCost,
    /** 총액 (공급가액 + 세액 + 배송비) */
    totalAmount
  };
};
